import React from "react";
import { Header } from "../../header";

export default () => {
  return (
    <div className="e-settings-layout">
      <Header title="Option Strategies" showMenu={false}></Header>
      <div className="e-settings-content">
        <p>
          Traders often jump into trading options with little understanding of
          the options strategies that are available to them. There are many
          options strategies that both limit risk and maximize return. With a
          little effort, traders can learn how to take advantage of the
          flexibility and power that options can provide.
        </p>

        <p>Common abbrevations used in option trading</p>
        <li>OTM stands for 'Out of The Money' option</li>
        <li>ATM stands for 'At The Money' option</li>
        <li>ITM stands for 'In The Money' option</li>

        <p>
          Here are 10 options strategies that every option trader should know.
        </p>

        <h3>1. Bull Call Spread</h3>
        <p>View: Moderately Bullish</p>
        <p>
          The ‘Bull Call Spread’ is best implemented when your outlook on the
          stock/index/commodity is ‘moderately bullish’ and not really
          ‘aggressive’. This strategy involves buying and selling Call option
          contracts
        </p>
        <p>
          To implement the bull call spread strategy
          <li>Buy 1 ATM call option (leg 1)</li>
          <li>Sell 1 OTM call option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Up</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/bull-call-spread/">
            https://zerodha.com/varsity/chapter/bull-call-spread/
          </a>
        </p>
        <h3>2. Bear Call Spread</h3>
        <p>View: Moderately Bearish</p>
        <p>
          The ‘Bear Call Spread’ is best implemented when your outlook on the
          stock/index/commodity is ‘moderately bearish’ and not really
          ‘aggressive’. This strategy involves buying and selling Call option
          contracts
        </p>
        <p>
          To implement the Bear call spread strategy
          <li>Buy 1 OTM Call option (leg 1)</li>
          <li>Sell 1 ITM Call option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Down</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/bear-call-spread/">
            https://zerodha.com/varsity/chapter/bear-call-spread/
          </a>
        </p>
        <h3>3. Bull Put Spread</h3>
        <p>View: Moderately Bullish</p>
        <p>
          The ‘Bull Put Spread’ strategy is best implemented when your outlook
          on the stock/index/commodity is ‘moderately bullish’ and not really
          ‘aggressive’. This strategy involves buying and selling Put option
          contracts
        </p>
        <p>
          To implement the bear call spread strategy
          <li>Buy 1 OTM Put option (leg 1)</li>
          <li>Sell 1 ITM Put option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Up</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/bull-put-spread/">
            https://zerodha.com/varsity/chapter/bull-put-spread/
          </a>
        </p>
        <h3>4. Bear Put Spread</h3>
        <p>View: Moderately Bearish</p>
        <p>
          The Bear Put Spread’ is best implemented when your outlook on the
          stock/index/commodity is ‘moderately bearish and not really
          ‘aggressive’. This strategy involves buying and selling Put option
          contracts
        </p>
        <p>
          To implement the bear put spread strategy
          <li>Buy 1 ITM Put option (leg 1)</li>
          <li>Sell 1 OTM Put option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Down</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/bear-put-spread/">
            https://zerodha.com/varsity/chapter/bear-put-spread/
          </a>
        </p>
        <h3>5. Short Straddle</h3>
        <p>View: Range bound market</p>
        <p>Duration: Close to expiry and less volatility</p>
        <p>
          Sell the ATM Call and Put option to set up short straddle strategy.
          Obviously the short strategy is set up for a net credit, as when you
          sell the ATM options, you receive the premium in your account.
        </p>
        <p>
          Avoid this strategy when there is too much volatity or more number of
          days to expiry
        </p>
        <p>
          To implement the short straddle strategy
          <li>Sell 1 ATM Put option (leg 1)</li>
          <li>Sell 1 ATM Call option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Neutral</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/the-short-straddle/">
            https://zerodha.com/varsity/chapter/the-short-straddle/
          </a>
        </p>
        <h3>5. Long Straddle</h3>
        <p>View: Very Bullish or Very Bearish </p>
        <p>Duration: More number of days to expiry</p>
        <p>
          The market can move in any direction, but it has to move. As long as
          the market moves (irrespective of its direction), a positive P&amp;L
          is generated
        </p>
        <p>
          Avoid this strategy in a range bound market. Premium decay will erode
          the capital in range bound market. This strategy is suitable before
          any big event that will trigger the price upside or downside.
        </p>
        <p>
          To implement the Long straddle strategy
          <li>Buy 1 ATM Put option (leg 1)</li>
          <li>Buy 1 ATM Call option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Extremely Positive</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/the-long-straddle/">
            https://zerodha.com/varsity/chapter/the-long-straddle/
          </a>
        </p>
        <h3>6. Short Strangle</h3>
        <p>View: Range bound market</p>
        <p>Duration: Close to expiry and less volatility</p>
        <p>
          Sell the OTM Call and Put option to set up short strangle strategy.
          The Short Strangle strategy has more probability of profit that Short
          Straddle Strategy. However the profit of Short Strangle is lesser than
          Short Straddle.
        </p>
        <p>
          Avoid this strategy when there is too much volatity or more number of
          days to expiry
        </p>
        <p>
          To implement the short strangle strategy
          <li>Sell 1 OTM Put option (leg 1)</li>
          <li>Sell 1 OTM Call option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Neutral</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/the-long-short-strangle/">
            https://zerodha.com/varsity/chapter/the-long-short-strangle/
          </a>
        </p>
        <h3>7. Long Strangle</h3>
        <p>View: Very Bullish or Very Bearish </p>
        <p>Duration: More number of days to expiry</p>
        <p>
          The market can move in any direction upside or downside, but it must
          move. Long Strangle costs less than Long Straddle strategy. However,
          Long Straddle gives more profit than Long Straddle Strategy.
        </p>
        <p>
          Avoid this strategy in a range bound market. Premium decay will erode
          the capital in range bound market. This strategy is suitable before
          any big event that will trigger the price upside or downside.
        </p>
        <p>
          To implement the Long strangle strategy
          <li>Buy 1 OTM Put option (leg 1)</li>
          <li>Buy 1 OTM Call option (leg 2)</li>
        </p>
        <p>
          You can open <b>Nifty option Strategies</b> and select <b>Extremely Bullish</b>
          view to see a practical example of this strategy
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/the-long-short-strangle/">
            https://zerodha.com/varsity/chapter/the-long-short-strangle/
          </a>
        </p>
        <h3>8. Call Ratio Back Spread</h3>
        <p>View: Very Bullish or Moderately Bearish</p>
        <p>
          This is an interesting strategy. It offers
          <li>Unlimited profit when market is very bullish</li>
          <li>Limited profit when market is bearish</li>
          <li>Limited loss when market is moderately bullish or range bound</li>
        </p>
        <p>
          To implement this strategy
          <li>Sell 1 ITM call option (leg 1)</li>
          <li>Buy 2 OTM call option (leg 2)</li>
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/call-ratio-back-spread/">
            https://zerodha.com/varsity/chapter/call-ratio-back-spread/
          </a>
        </p>
        <h3>9. Bear Call Ladder</h3>
        <p>View: Very Bullish or Moderately Bearish</p>
        <p>
          This is another interesting strategy similar to Call Ratio Back Spread
          strategy. It offers
          <li>Unlimited profit when market is very bullish</li>
          <li>Limited profit when market is bearish</li>
          <li>Limited loss when market is moderately bullish or range bound</li>
        </p>
        <p>
          This is a 3 leg strategy. To implement this strategy
          <li>Sell 1 ITM call option (leg 1)</li>
          <li>Buy 1 ATM call option (leg 2)</li>
          <li>Buy 1 OTM call option (leg 3)</li>
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/bear-call-ladder/">
            https://zerodha.com/varsity/chapter/bear-call-ladder/
          </a>
        </p>
        <h3>10. Put Ratio Back Spread</h3>
        <p>View: Very Bearish or Moderately Bullish</p>
        <p>
          This strategy involves buying and selling put options. It offers
          <li>Unlimited profit when market is very bearish</li>
          <li>Limited profit when market is bullish</li>
          <li>Limited loss when market is moderately bearish or range bound</li>
        </p>
        <p>
          To implement this strategy
          <li>Sell 1 ITM put option (leg 1)</li>
          <li>Buy 2 OTM put option (leg 2)</li>
        </p>
        <p>
          For more detailed explanation refer &nbsp;
          <a href="https://zerodha.com/varsity/chapter/put-ratio-back-spread/">
            https://zerodha.com/varsity/chapter/put-ratio-back-spread/
          </a>
        </p>
      </div>
    </div>
  );
};
